import './header.scss';

import { TopHeader } from '@transferz/fe-component-library/src/components/topHeader/TopHeader';
import { useLocalize } from 'localize-react';
import React from 'react';

import { Language } from '../../components/language/Language';

export const Header: React.FC = () => {
  const helpdeskUrl = window?.tz_globalConfigs?.helpdeskUrl || 'https://booking.taxi2airport.com/help';
  const helpdeskUrlHide = window?.tz_globalConfigs?.helpdeskUrlHide;
  const { translate } = useLocalize();

  return (
    <TopHeader
      language={<Language />}
      helpdeskUrl={!helpdeskUrlHide ? helpdeskUrl : null}
      logoUrl={window?.tz_globalConfigs?.styling?.logoUrl}
      borderColor={window?.tz_globalConfigs?.styling?.primaryColor || '#F6C82F'}
      helpdeskLabel={translate('b_helpDesk')}
    />
  );
};
